import {Component, ElementRef, ViewChild, inject, Inject} from '@angular/core';
import {CustomChannelWithFavorites} from "../../model/customChannelWithFavorites";
import {ChannelsService} from "../../services/channels.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {AppConfigService} from "../../app-config.service";
import {CategoryList} from "../../model/categoryList";
import {SearchItem} from "../../model/searchItem";
import {ListItem} from "../../model/listItem";
import {ApiRequestService} from "../../services/api-request.service";
import {UserService} from "../../services/user.service";
import {MetricsService} from "../../services/metrics.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent {

    public excludeCategories = this.appConfig.getHiddenCategories();
    public get showIneligibleChannels(): Boolean {
        return ( this.appConfig.getShowIneligibleChannels() );
    }
    public get showChannelEligibility(): Boolean {
        return ( this.appConfig.getShowChannelEligibility() );
    }

    public channelList: Array<CustomChannelWithFavorites> = [];
    public viewedList: Array<ListItem> = [];

    private minTermLength: number = 3;
    public primarySearchResults: Array<CustomChannelWithFavorites> = [];
    protected keywords: string;
    public  searchTerms: Array<string> = [];
    public searchResults: Array<SearchItem> = [];

    public searchCurrentPage: number = 1;
    public searchPageSize: number;
    public get searchCollectionSize(): number {  return this.searchResults.length; }
    public showSearchResults: boolean = false;
    public searchResultsIsLoading: boolean = false;
    public searchResultsEmpty: boolean = false;
    public refreshToken: boolean = false;
    private gaTimeout: any = 0;
    private processTimeout: any = 0;
    private skipGASearchEvent: boolean = false;
    public showNoResultsFound: boolean = false;
    private modalService: NgbModal = inject(NgbModal);
    private window: Window;
    constructor(
        private activatedRoute: ActivatedRoute,
        private channelService: ChannelsService,
        private router: Router,
        private appConfig: AppConfigService,
        private api: ApiRequestService,
        private userService: UserService,
        private metricsService: MetricsService,
        private fb: UntypedFormBuilder,
        @Inject('Window') window: Window
    ) {
        this.window = window;
        this.searchPageSize = this.appConfig.getSearchPageSize();
    }

    get CPKBUrl() { return this.appConfig.getCP_KB_Url(); }
    get LIBKBUrl() { return this.appConfig.getLIB_KB_Url(); }
    get ITSKBUrl() { return this.appConfig.getITS_KB_Url(); }
    get STUKBUrl() { return this.appConfig.getSTU_KB_Url(); }
    get hasStudentRole() { return ( this.userService.hasRole("student") && !this.userService.hasRole("employee") ); }

    ngOnInit(): void {
        let me = this;
        me.channelList = me.channelService.getAllChannels();
        me.viewedList = me.sortIntoCategories();
        this.channelService.channelsReady$.subscribe( () => {
            me.channelList = me.channelService.getAllChannels();
            me.viewedList = me.sortIntoCategories();
        } );
        this.activatedRoute.queryParams.subscribe( {
            next: (routeParams: Params) => {
                if ( routeParams['keyword'] != undefined ) {
                    // let regex = new RegExp(/\w+/g);
                    me.keywords = routeParams['keyword'].replace(/[^\w ]+/g, "").toLowerCase( );
                    me.sanitizeSearchTerm();
                } else {
                    me.router.navigate(["/services"]);
                }
            }
        });
        this.channelService.liveSearchReady$.subscribe({
            next: (keywords: string) => {
                me.keywords = keywords.replace(/[^\w ]+/g, "").toLowerCase( );
                me.sanitizeSearchTerm();
            }
        });
    }

    public getSearchTerms() {
        return this.searchTerms.join(' ');
    }

    public sortIntoCategories() {
        let me = this;
        // let categories: Array<string> = [];
        let newViewedList: Array<ListItem> = [];
        me.channelList = me.channelList.sort((a:any, b:any) => a.title.localeCompare(b.title));
        me.channelList.forEach( (el:CustomChannelWithFavorites) => {
            let newItem: ListItem = {
                title: el.title,
                description: el.description,
                keywords: el.keywords,
                goname: el.goname,
                category: el.category,
                is_visible: false,
                is_college: el.is_college,
                is_public: el.is_public,
                included_roles: ( el.include_roles == null ? [] : el.include_roles.split(',') ),
                excluded_roles: ( el.exclude_roles == null ? [] : el.exclude_roles.split(',') ),
                has_access: this.channelService.hasChannelAccess(el),
                eligibility: el.eligibility,
                is_student_channel: me.channelService.channelHasStudentRole(el),
                is_employee_channel: me.channelService.channelHasEmployeeRole(el),
                has_visibility: me.channelService.userHasVisibilityAccess()
            }
            if ( el.category != 'Icon' ) {
                newViewedList.push( newItem );
            }
        } );

        newViewedList = newViewedList.sort((a:any, b:any) => a.title.localeCompare(b.title));
        return newViewedList;
    }

    /** SEARCH **/
    public sanitizeSearchTerm() {
        let me = this;
        let stopwords = ["a", "about", "above", "above", "across", "after", "afterwards", "again", "against", "all", "almost", "alone", "along", "already", "also", "although", "always", "am", "among", "amongst", "amoungst", "amount", "an", "and", "another", "any", "anyhow", "anyone", "anything", "anyway", "anywhere", "are", "around", "as", "at", "back", "be", "became", "because", "become", "becomes", "becoming", "been", "before", "beforehand", "behind", "being", "below", "beside", "besides", "between", "beyond", "bill", "both", "bottom", "but", "by", "call", "can", "cannot", "cant", "co", "con", "could", "couldnt", "cry", "de", "describe", "detail", "do", "done", "down", "due", "during", "each", "eg", "eight", "either", "eleven", "else", "elsewhere", "empty", "enough", "etc", "even", "ever", "every", "everyone", "everything", "everywhere", "except", "few", "fifteen", "fify", "fill", "find", "fire", "first", "five", "for", "former", "formerly", "forty", "found", "four", "from", "front", "full", "further", "get", "give", "go", "had", "has", "hasnt", "have", "he", "hence", "her", "here", "hereafter", "hereby", "herein", "hereupon", "hers", "herself", "him", "himself", "his", "how", "however", "hundred", "ie", "if", "in", "inc", "indeed", "interest", "into", "is", "it", "its", "itself", "keep", "last", "latter", "latterly", "least", "less", "ltd", "made", "many", "may", "me", "meanwhile", "might", "mill", "mine", "more", "moreover", "most", "mostly", "move", "much", "must", "my", "myself", "name", "namely", "neither", "never", "nevertheless", "next", "nine", "no", "nobody", "none", "noone", "nor", "not", "nothing", "now", "nowhere", "of", "off", "often", "on", "once", "one", "only", "onto", "or", "other", "others", "otherwise", "our", "ours", "ourselves", "out", "over", "own", "part", "per", "perhaps", "please", "put", "rather", "re", "same", "see", "seem", "seemed", "seeming", "seems", "serious", "several", "she", "should", "show", "side", "since", "sincere", "six", "sixty", "so", "some", "somehow", "someone", "something", "sometime", "sometimes", "somewhere", "still", "such", "system", "take", "ten", "than", "that", "the", "their", "them", "themselves", "then", "thence", "there", "thereafter", "thereby", "therefore", "therein", "thereupon", "these", "they", "thickv", "thin", "third", "this", "those", "though", "three", "through", "throughout", "thru", "thus", "to", "together", "too", "top", "toward", "towards", "twelve", "twenty", "two", "un", "under", "until", "up", "upon", "us", "very", "via", "was", "we", "well", "were", "what", "whatever", "when", "whence", "whenever", "where", "whereafter", "whereas", "whereby", "wherein", "whereupon", "wherever", "whether", "which", "while", "whither", "who", "whoever", "whole", "whom", "whose", "why", "will", "with", "within", "without", "would", "yet", "you", "your", "yours", "yourself", "yourselves", "the"];
        this.searchTerms = [];
        let filterAr = this.keywords.trim().split(' ');
        filterAr.forEach( (el:string) => {
            if ( !stopwords.includes(el) && el != "" ) {
                me.searchTerms.push( el.trim() );
            }
        } );
        if ( me.processTimeout == 0 ) {
            me.processTimeout = setTimeout(() => {
                me.processSearchTerms();
                if ( me.searchTimeoutID != null ){
                    clearTimeout( me.searchTimeoutID );
                }
                if ( this.appConfig.isUsaskSearchEnabled() && this.keywords.length >= this.minTermLength ) {
                    me.searchWiki();
                }
            }, 200);
        }
    }
    private processSearchTerms() {
        let me = this;
        me.primarySearchResults = [];
        let hasResults = false;
        me.viewedList.forEach( (item:ListItem,index:number) => {
            if (
                me.searchTerms.length == 0
                // || me.searchTerms.some( t => { return item.title.search(new RegExp(t, "i")) >= 0; } )
                // || ( this.searchTerms.some( t => { return ( item.description != null ? item.description.search(new RegExp(t, "i")) >= 0 : false ); } ) )
                // || ( this.searchTerms.some( t => { return ( item.keywords != null ? item.keywords.search(new RegExp(t, "i")) >= 0 : false ); } ) )
            ) {
                // console.log( "1: " + item.title );
                me.viewedList[index].is_visible = true;
                hasResults = true;
                // hidecat = false;
            } else if (
                me.searchTerms.some( t => { return item.title.search(new RegExp(t, "i")) >= 0; } )
                && item.has_access
                && !me.excludeCategories.includes( item.category )
            ) {
                // console.log("2: " + item.title);
                let newItem = {...item};
                newItem.is_visible = true;
                me.primarySearchResults.push(newItem);
                me.viewedList[index].is_visible = false;
                hasResults = true;
            } else if (
                (
                    this.searchTerms.some( t => { return ( item.description != null ? item.description.search(new RegExp(t, "i")) >= 0 : false ); } )
                    || this.searchTerms.some( t => { return ( item.keywords != null ? item.keywords.search(new RegExp(t, "i")) >= 0 : false ); } )
                )
                && !me.excludeCategories.includes( item.category )
            ) {
                // console.log( "3: " + item.title );
                me.viewedList[index].is_visible = true;
                // hidecat = false;
                hasResults = true;
            } else {
                // console.log( "4: " + item.title );
                me.viewedList[index].is_visible = false;
            }
            // UNCOMMENT IF Hiding ineligible channels channels
            if ( !me.userHasFullAccess( item ) ) {
                // console.log(item);
                // console.log( "5: " + item.title );
                me.viewedList[index].is_visible = false;
                // console.log(me.viewedList[index]);
            }
        } );
        me.showNoResultsFound = !hasResults;
        me.processTimeout = 0;
        if ( me.gaTimeout == 0 && !me.skipGASearchEvent ) {
            me.gaTimeout = setTimeout( () => {
                me.sendGASearchEvent();
                me.gaTimeout = 0;
                me.skipGASearchEvent = false;
            }, 3000 );
        } else {
            me.skipGASearchEvent = false;
        }
        // console.log( me.viewedList );
    }
    private searchTimeoutID: any = null;
    public searchWiki() {
        let me = this;
        let keywords = this.searchTerms;
        me.searchResults = [];
        me.showSearchResults = true;
        me.searchCurrentPage = 1;
        if ( me.searchTimeoutID != null ) {
            clearTimeout( me.searchTimeoutID );
            me.searchTimeoutID = null;
        }
        if ( me.searchTimeoutID == null ) {
            me.searchResultsIsLoading = true;
            me.searchResultsEmpty = false;
            me.refreshToken = false;
            me.searchTimeoutID = setTimeout(() => {
                me.api.searchUsask(keywords.join(' ')).subscribe({
                    next: (resp: any) => {
                        me.searchResults = resp.data;
                        me.searchResultsIsLoading = false;
                        if (resp.data == undefined || resp.data.length == 0) {
                            me.searchResultsEmpty = true;
                        }
                    }, error: (error) => {
                        // console.log( error );
                        if ( error.status == 401 ) {
                            me.refreshToken = true;
                            me.router.navigate(["/login"], { queryParams: { "channel": "search?keyword=" + me.keywords }, replaceUrl: true });
                        } else {
                            me.searchResultsEmpty = true;
                        }
                        me.searchResultsIsLoading = false;
                    }, complete: () => {
                        me.searchTimeoutID = null;
                    }
                });
            }, 2000);
        }
    }
    public sendGASearchEvent() {
        if ( this.searchTerms.length > 0 ) {
            let searchString = this.searchTerms.join(" ");
            if ( searchString != '' ) {
                this.metricsService.sendSearchTermView(searchString);
            }
        }
    }
    public sendGAClickEvent( title: string ) {
        if ( title != '' ) {
            // this.metricsService.sendChannelListClick(title);
        }
    }
    public hasRole( role: string ) {
        return this.userService.hasRole(role);
    }
    public get searchString() {
        return this.searchTerms.join(' ');
    }
    public userHasFullAccess( channel: ListItem ) {
        // console.log( "userHasFullAccess: " + channel.title + ": " + this.channelService.userHasFullAccess( channel ) );
        // return this.channelService.userHasFullAccess( channel );
        return channel.has_access;
    }
    public userHasVisibilityAccess( channel: ListItem ) {
        // return this.channelService.userHasVisibilityAccess(  );
        return channel.has_visibility;
    }
    public isStudentChannel( channel: ListItem ) {
        // return this.channelService.channelHasStudentRole( channel );
        return channel.is_student_channel;
    }
    public isEmployeeChannel( channel: ListItem ) {
        return channel.is_employee_channel;
    }
    public convertTDXLink( link: string ) {
        if ( link.includes("https://teamdynamix.usask.ca") ) {
            link = link.replace("https://teamdynamix.usask.ca","");
            return this.appConfig.getTDXLoginUrl() + link;
        } else {
            return link;
        }
    }
}
